import cx from 'classnames';

import { SidebarLink } from '../../components/SidebarLink';
import { createDashboardSidebarItem } from '../../lib';
import { useActiveLocationPath } from '../../service';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

const ITEM = createDashboardSidebarItem();

export const DashboardItem = ({ className }) => {
  const styles = useStyles();

  const activePath = useActiveLocationPath();

  const { handleItemClick } = useHandlers();

  return (
    <SidebarLink
      className={cx(styles.root, className)}
      item={ITEM}
      active={ITEM.path === activePath}
      onClick={handleItemClick}
    />
  );
};
